import React from "react";


const Image = ( {data} ) => {
    return(
        <img className="rounded-2xl" src={data.img} alt=""/>
    );
};

export default Image;